import React, { useState } from 'react';

interface Props {
  value: string;
  onSave: (newValue: string) => Promise<void>;
  multiline?: boolean;
  style?: React.CSSProperties;
}

export default function EditableField({ value, onSave, multiline = false, style }: Props) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(draft);
      setEditing(false);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setDraft(value);
    setEditing(false);
  };

  if (!editing) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'flex-start', gap: 8, ...style }}>
        <span>{value}</span>
        <button onClick={() => setEditing(true)} style={btnStyle('#1a3a6b')}>✏️ Изменить</button>
      </span>
    );
  }

  return (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 6, width: '100%', ...style }}>
      {multiline ? (
        <textarea
          value={draft}
          onChange={e => setDraft(e.target.value)}
          rows={4}
          style={inputStyle}
          autoFocus
        />
      ) : (
        <input
          value={draft}
          onChange={e => setDraft(e.target.value)}
          style={inputStyle}
          autoFocus
        />
      )}
      <span style={{ display: 'flex', gap: 8 }}>
        <button onClick={handleSave} disabled={saving} style={btnStyle('#27ae60')}>
          {saving ? 'Сохранение...' : '💾 Сохранить'}
        </button>
        <button onClick={handleCancel} style={btnStyle('#888')}>Отмена</button>
      </span>
    </span>
  );
}

const inputStyle: React.CSSProperties = {
  padding: '8px 12px',
  borderRadius: 6,
  border: '1px solid #1a3a6b',
  fontSize: '1rem',
  width: '100%',
  outline: 'none',
};

const btnStyle = (bg: string): React.CSSProperties => ({
  padding: '5px 12px',
  background: bg,
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontSize: '0.82rem',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
});
